import { globalStyles } from '@client/shared/constants';

const style = {
  dragWrapper: {
    border: '1px dotted #80CAF9',
    backgroundColor: 'grey.100'
  },
  audioPlayerWrapper: {
    '& audio': {
      border: '1px solid #ccc',
      height: 36,
      width: '100%',
      borderRadius: 2,
    },
    '& audio::-webkit-media-controls-panel': {
      width: '100%',
      backgroundColor: '#fff',
    }
  },
  recordingActions: {
    width: 104
  },
  uploadNotes: {
    fontSize: 13,
  },
  heading: {
    fontWeight: "bold",
    marginTop: "8px",
    marginBottom: "8px",
  },
  infoBtn: {
    marginTop: "14px",
    width: "120px",
    height: "140px",
  },
  dragging: {
    backgroundColor: 'grey.200'
  }
};

export default style;